<template>
<main class="main-wrapper flex-grow-1 bg-documentGray">
		<div class="d-flex align-items-center ">
			<div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
					<div class="font-m">{{this.$t('995')}}</div>
			</div>
		</div>
		<div class="divider"></div>
		<TopAppBarExamListTab> </TopAppBarExamListTab>
		<div class="container mgt-30">
		
<!-- <img src="images/banner.svg" alt="" class="b-radius4"> -->
		<div v-if="campaignData && campaignData.locationValue === '0'">
			<a class="d-block" v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank">
				<img :src="campaignData.image" :alt="campaignData.dynamicLink.name" class="b-radius4 survey-banner" />
			</a>
		
			<a class="d-block" v-else href="javascript:void(0)" target="_blank">
				<img :src="campaignData.image" alt="" class="b-radius4 survey-banner" />
			</a>
		</div>
		<div class="mgt-30 d-flex justify-content-between">
				<div class="t-body6 t-color-bodyGrayA l-spacing45 t-line-h-22 font-r flex-grow-1">{{$t('999', {str: totalExamCount})}}</div>
				<button class="material-icons mdc-icon-button test-list-toggler active mgt--12 mgb--12" v-if="listType === 'card'">
					<img src="/images/survey/view-carousel.svg" alt="">
				</button>
				<button class="material-icons mdc-icon-button test-list-toggler active mgt--12 mgb--12" @click="changeMode('card')" @keypress="changeMode('card')" tabindex="0" v-else>
					<img src="/images/survey/view-carousel-inactive.svg" alt="">
				</button>
					<button  v-if="listType === 'list'" 
						class="material-icons mdc-icon-button mgr--14 test-list-toggler mgt--12 mgb--12 active rtl-support">
						view_list
				</button>
				<button  v-else
					@click="changeMode('list')" @keypress="changeMode('list')" tabindex="0"
					class="material-icons mdc-icon-button mgr--14 test-list-toggler mgt--12 mgb--12 rtl-support">
					view_list
				</button>
		</div>
		<div class="divider mgt-16 mgb-16"></div>
</div>
<NoData :msgData="{msg1:'3073',msg2:'3074'}" v-if="isNoData"></NoData>
		<component
			:is="listType"
			:listData="listData"
			:campaignData="campaignData"
		></component>

		<infinite-loading @infinite="fetchData" spinner="spiral">
			<div slot="no-more" class="pdt-10 pdb-16"><!--No more data--></div>
			<div slot="no-results" class="pdt-10 pdb-16"></div>
		</infinite-loading>
</main>
</template>

<script>
/**
 * 단독 전체 시험 목록 메인 컴포넌트(independent total exam list main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import examApi from '@/api/examApi.js'
import campaignApi from '@/api/campaignApi.js'
import NoData from '../../common/NoData.vue'
import InfiniteLoading from 'vue-infinite-loading'
import TopAppBarExamListTab from "../../TopAppBarExamListTab.vue";
export default {
	
	name: 'examTotal',
	components: {
		'card': () => import('@/components/independentExam/list/TotalCard.vue'),
		'list': () => import('@/components/independentExam/list/TotalList.vue'),
		NoData,
		InfiniteLoading,
		TopAppBarExamListTab
	},

	data() {
		return {
			listType: 'card',
			isNoData: false,
			
			totalExamCount: 0,
			campaignData: null,

			listData: [],
			currentPage: 1,
			totalPages: 1
		}
	},
	
	mounted() {
		// get total exam count
		examApi.guestExamOnlineCount().then((response) => {
			this.totalExamCount = response.data.data
		})
		
	},

	updated() {
		const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
			let ripple = new MDCRipple.attachTo(el)
			return ripple
		})
	},

	methods: {
		changeMode(mode) {
			this.listType = mode
		},

		// 목록 데이터 호출(get exam list data)
		fetchData($state) {
			let responseData = null
			let params = this.setParams()

			if (this.totalPages >= this.currentPage) {
				examApi.guestExamOnlineCategoryList(params).then((response) => {
					let responseData = response.data.data
					
					this.listData = this.listData.concat(responseData.content)

					this.currentPage++
					this.totalPages = responseData.totalPages
					
					if (responseData.content.length) {
						$state.loaded()
					}else {
						$state.complete()
					}
					//if (!this.listData.length) {
                    if (this.totalExamCount===0) {
                        this.isNoData = true
                    }
				})

			}else {
				$state.complete()
			}

			// 캠페인 테이터 API 호출(get campaign data)
			campaignApi.campaign({locationType: 'INDEPENDENT_EXAM_LIST'}).then((response) => {
				// console.log('campaign response.data.data', response.data.data);
				this.campaignData = response.data.data
			}).catch((err) => {})

		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				itemCount: 10,
				page: this.currentPage,
				size: 10,
				sort: 'id,desc'
			}
			return params
		},
	}
}
</script>